









































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import '@/compiled-icons/check';
import '@/compiled-icons/error-outline';
import {SortableEvent} from 'sortablejs';
import AdvancedConfirmDialog, {ConfirmationDialogConfig} from '@/views/AdvancedConfirmDialog.vue';
import draggable from 'vuedraggable';
import {cloneDeep} from 'lodash';
import AmetrasSignatureFieldTemplate from '@/fields/signature/AmetrasSignatureFieldTemplate.vue';
import AmetrasDateFieldTemplate from '@/fields/date/AmetrasDateFieldTemplate.vue';
import AmetrasTextFieldTemplate from '@/fields/text/AmetrasTextFieldTemplate.vue';
import AmetrasMonthFieldTemplate from '@/fields/date/AmetrasMonthFieldTemplate.vue';
import AmetrasNumberFieldTemplate from '@/fields/text/AmetrasNumberFieldTemplate.vue';
import AmetrasTextAreaFieldTemplate from '@/fields/text-area/AmetrasTextAreaFieldTemplate.vue';
import DynamicDocumentListTableFieldTemplate from '@/views/dynamicdocuments/fields/dynamic-document-list-table-field-template.vue';
import AmetrasCheckBoxTemplate from '@/fields/checkbox/AmetrasCheckBoxTemplate.vue';

import '@/compiled-icons/add';
import '@/compiled-icons/arrow-down';
import '@/compiled-icons/arrow-up';
import '@/compiled-icons/delete';
import '@/compiled-icons/close';
import '@/compiled-icons/table-insert-after';
import '@/compiled-icons/table-insert-before';
import '@/compiled-icons/table-column-plus-after';
import '@/compiled-icons/table-column-plus-before';
import '@/compiled-icons/pencil-outline';
import '@/compiled-icons/drag-horizontal-variant';
import '@/compiled-icons/drag-vertical-variant';
import '@/compiled-icons/format-align-top';
import '@/compiled-icons/format-align-bottom';
import '@/compiled-icons/format-align-middle';
import '@/compiled-icons/format-page-break';
import DynamicDocumentNumberBrickTemplate from '@/views/dynamicdocuments/bricks/dynamic-document-number-brick-template.vue';
import DynamicDocumentTextBrickTemplate from '@/views/dynamicdocuments/bricks/dynamic-document-text-brick-template.vue';
import DynamicDocumentDateBrickTemplate from '@/views/dynamicdocuments/bricks/dynamic-document-date-brick-template.vue';
import DynamicDocumentYearMonthBrickTemplate from '@/views/dynamicdocuments/bricks/dynamic-document-year-month-brick-template.vue';
import DynamicDocumentSignatureBrickTemplate from '@/views/dynamicdocuments/bricks/dynamic-document-signature-brick-template.vue';
import DynamicDocumentCheckboxBrickTemplate from '@/views/dynamicdocuments/bricks/dynamic-document-checkbox-brick-template.vue';
import DynamicDocumentMachineWorkingAreaBoundaryBrickTemplate from '@/views/dynamicdocuments/bricks/dynamic-document-machine-working-area-boundary-brick-template.vue';
import AmetrasMachineWorkingAreaBoundaryTemplate from '@/fields/machine-working-area-boundary/AmetrasMachineWorkingAreaBoundaryTemplate.vue';

interface ContentDialogButton {
  onClick: (button: ContentDialogButton,
            content: DisguiseDto.DynamicDocumentFieldDtoV2,
            event: Event) => void;
  loading: boolean;
  disabled: boolean;
  title: string;
  icon: string;
  iconSize?: 'LARGE' | 'DEFAULT';
}

interface ContentDialog {
  headerButtons?: ContentDialogButton[];
  content?: DisguiseDto.DynamicDocumentFieldDtoV2;
  onClose?: () => void;
  title?: string;
  maxWidth?: string | number;
}

export type RowDesignerContentTypes = 'DynamicDocumentFieldTypeCheckboxDto'
    | 'DynamicDocumentFieldTypeDateDto'
    | 'DynamicDocumentFieldTypeListTableDto'
    | 'DynamicDocumentFieldTypeNumberDto'
    | 'DynamicDocumentFieldTypeSignatureDto'
    | 'DynamicDocumentFieldTypeTextDto'
    | 'DynamicDocumentFieldTypeYearMonthDto';
@Component({
  name: 'dynamic-document-rows-designer',
  components: {
    AmetrasMachineWorkingAreaBoundaryTemplate,
    DynamicDocumentMachineWorkingAreaBoundaryBrickTemplate,
    DynamicDocumentListTableBrickTemplate: () => import('@/views/dynamicdocuments/bricks/dynamic-document-list-table-brick-template.vue'),
    DynamicDocumentCheckboxBrickTemplate,
    DynamicDocumentSignatureBrickTemplate,
    DynamicDocumentYearMonthBrickTemplate,
    DynamicDocumentDateBrickTemplate,
    DynamicDocumentTextBrickTemplate,
    DynamicDocumentNumberBrickTemplate,
    AmetrasCheckBoxTemplate,
    DynamicDocumentListTableFieldTemplate,
    AmetrasTextAreaFieldTemplate,
    AmetrasNumberFieldTemplate,
    AmetrasMonthFieldTemplate,
    AmetrasTextFieldTemplate,
    AmetrasDateFieldTemplate,
    AmetrasSignatureFieldTemplate,
    AdvancedConfirmDialog,
    draggable,
  }
})
export default class DynamicDocumentRowsDesignerTemplate extends Vue {

  @Prop({
    default: () => {
      return [];
    }
  }) value!: DisguiseDto.DynamicDocumentRowDtoV2[];
  @Prop() context!: DisguiseDto.DynamicDocumentContextDto;
  @Prop({
    default: 'rows'
  }) rowDragGroup!: string;
  @Prop({
    default: 'fields'
  }) fieldDragGroup!: string;
  @Prop({
    default: false
  }) readonly!: boolean;
  @Prop({
    default: false
  }) fieldsEditable!: boolean;
  @Prop({
    default: true
  }) verticalAlignEditable!: boolean;
  @Prop({
    default: false
  }) pageBreakAllowed!: boolean;
  @Prop({
    default: () => {
      return new Set([
        'DynamicDocumentFieldTypeCheckboxDto',
        'DynamicDocumentFieldTypeDateDto',
        'DynamicDocumentFieldTypeListTableDto',
        'DynamicDocumentFieldTypeNumberDto',
        'DynamicDocumentFieldTypeSignatureDto',
        'DynamicDocumentFieldTypeTextDto',
        'DynamicDocumentFieldTypeYearMonthDto',
        'DynamicDocumentFieldTypeMachineWorkingAreaBoundaryDtoV2',
      ]);
    }
  }) supportedContentTypes!: Set<RowDesignerContentTypes>;
  showConfirmationDialog: boolean = false;
  confirmationDialogConfig: ConfirmationDialogConfig | undefined;
  contentDialog: ContentDialog = {};
  showContentDialog: boolean = false;

  startDragging(event: SortableEvent) {
    event.item.classList.add('document__row--handle-grabbed');
  }

  endDragging(event: SortableEvent) {
    event.item.classList.remove('document__row--handle-grabbed');
  }

  startDraggingItem(event: SortableEvent) {
    event.item.classList.add('document__row__contents__item__menu__handle-btn--handle-grabbed');
  }

  endDraggingItem(event: SortableEvent) {
    event.item.classList.remove('document__row__contents__item__menu__handle-btn--handle-grabbed');
  }

  updateRowOrder(event: DisguiseDto.DynamicDocumentRowDtoV2[]) {
    this.$emit('input', event);
  }

  addRow(rows: DisguiseDto.DynamicDocumentRowDtoV2, targetPosition?: number) {
    const clonedCurrentValue = cloneDeep(this.value);
    const newRowStub: DisguiseDto.DynamicDocumentRowDtoV2 = {
      '@type': 'DynamicDocumentRowDtoV2',
      'fields': []
    };
    if (targetPosition === undefined) {
      clonedCurrentValue.push(newRowStub);
    } else {
      clonedCurrentValue.splice(targetPosition, 0, newRowStub);
    }
    this.$emit('input', clonedCurrentValue);
  }

  deleteRow(row: DisguiseDto.DynamicDocumentRowDtoV2, rows: DisguiseDto.DynamicDocumentRowDtoV2[]) {
    if (row.fields && row.fields.length > 0) {
      // row has fields
      this.confirmationDialogConfig = {
        title: 'Zeile Löschen',
        message: `Wollen Sie diese Zeile wirklich löschen?`,
        onEsc: () => {
          this.showConfirmationDialog = false;
        },
        headerColor: 'primary',
        buttons: [{
          title: 'Abbrechen',
          text: 'Abbrechen',
          loading: false,
          disabled: false,
          onClick: () => {
            this.showConfirmationDialog = false;
          }
        }, {
          title: 'Bestätigen',
          text: 'Bestätigen',
          loading: false,
          disabled: false,
          autoFocus: true,
          onClick: () => {
            if (row) {
              rows.splice(rows.indexOf(row) || 0, 1);
            }
            this.showConfirmationDialog = false;
          }
        }]
      };
      this.showConfirmationDialog = true;
    } else {
      // row is empty
      rows.splice(rows.indexOf(row) || 0, 1);
    }
  }


  deleteItem(rowField: DisguiseDto.DynamicDocumentFieldDtoV2, row: DisguiseDto.DynamicDocumentRowDtoV2) {
    // row has fields
    this.confirmationDialogConfig = {
      title: 'Feld Löschen',
      message: `Wollen Sie das Feld wirklich löschen?`,
      onEsc: () => {
        this.showConfirmationDialog = false;
      },
      headerColor: 'primary',
      buttons: [{
        title: 'Abbrechen',
        text: 'Abbrechen',
        loading: false,
        disabled: false,
        onClick: () => {
          this.showConfirmationDialog = false;
        }
      }, {
        title: 'Bestätigen',
        text: 'Bestätigen',
        loading: false,
        disabled: false,
        autoFocus: true,
        onClick: () => {
          if (row && row.fields) {
            row.fields.splice(row.fields.indexOf(rowField) || 0, 1);
          }
          this.showConfirmationDialog = false;
        }
      }]
    };
    this.showConfirmationDialog = true;
  }


  editFormField(
      formField: DisguiseDto.DynamicDocumentFieldDtoV2,
      row: DisguiseDto.DynamicDocumentRowDtoV2
  ) {
    if (formField && formField.fieldType) {
      switch (formField.fieldType['@type']) {
        case 'DynamicDocumentFieldTypeSignatureDtoV2':
          this.createEditContentDialog('Unterschrift bearbeiten', formField, row);
          break;
        case 'DynamicDocumentFieldTypeCheckboxDtoV2':
          this.createEditContentDialog('Checkbox bearbeiten', formField, row);
          break;
        case 'DynamicDocumentFieldTypeListTableDtoV2':
          this.createEditContentDialog('Tabelle bearbeiten', formField, row, '90%');
          break;
        case 'DynamicDocumentFieldTypeTextDtoV2':
          this.createEditContentDialog('Textbaustein bearbeiten', formField, row);
          break;
        case 'DynamicDocumentFieldTypeNumberDtoV2':
          this.createEditContentDialog('Zahlenbaustein bearbeiten', formField, row);
          break;
        case 'DynamicDocumentFieldTypeDateDtoV2':
          this.createEditContentDialog('Datumbaustein bearbeiten', formField, row);
          break;
        case 'DynamicDocumentFieldTypeYearMonthDtoV2':
          this.createEditContentDialog('Monatbaustein bearbeiten', formField, row);
          break;
        case 'DynamicDocumentFieldTypeMachineWorkingAreaBoundaryDtoV2':
          this.createEditContentDialog('Arbeitsbereichsbegrenzung bearbeiten', formField, row);
          break;
      }
    }
  }

  createTextField(row: DisguiseDto.DynamicDocumentRowDtoV2, targetPosition?: number) {
    this.createNewContentDialog(
        'Textbaustein erstellen',
        {
          '@type': 'DynamicDocumentFieldDtoV2',
          'fieldType': {
            '@type': 'DynamicDocumentFieldTypeTextDtoV2',
            'label': '',
            'value': '',
            'readOnly': false,
            'multiline': false,
            'maxLength': undefined,
            'horizontalAlignment': 'LEFT',
            'mandatory': false,
            'valueFontSize': undefined,
            'valueBold': false,
            'valueItalic': false,
            'labelFontSize': undefined,
            'labelBold': false,
            'labelItalic': false,
            'labelColorHex': undefined,
            'valueColorHex': undefined,
          }
        },
        row,
        targetPosition
    );
  }

  createNumberField(row: DisguiseDto.DynamicDocumentRowDtoV2, targetPosition?: number) {
    this.createNewContentDialog(
        'Zahlenbaustein erstellen',
        {
          '@type': 'DynamicDocumentFieldDtoV2',
          'fieldType': {
            '@type': 'DynamicDocumentFieldTypeNumberDtoV2',
            'label': '',
            'context': undefined,
            'value': undefined,
            'min': undefined,
            'max': undefined,
            'places': undefined,
            'readOnly': false,
            'horizontalAlignment': 'RIGHT',
            'mandatory': false,
            'valueFontSize': undefined,
            'valueBold': false,
            'valueItalic': false,
            'labelFontSize': undefined,
            'labelBold': false,
            'labelItalic': false,
            'labelColorHex': undefined,
            'valueColorHex': undefined,
          }
        },
        row,
        targetPosition
    );
  }

  createDateField(row: DisguiseDto.DynamicDocumentRowDtoV2, targetPosition?: number) {
    this.createNewContentDialog(
        'Datumbaustein erstellen',
        {
          '@type': 'DynamicDocumentFieldDtoV2',
          'fieldType': {
            '@type': 'DynamicDocumentFieldTypeDateDtoV2',
            'label': '',
            'context': undefined,
            'value': undefined,
            'min': undefined,
            'max': undefined,
            'readOnly': false,
            'horizontalAlignment': 'LEFT',
            'mandatory': false,
            'valueFontSize': undefined,
            'valueBold': false,
            'valueItalic': false,
            'valueColorHex': undefined,
            'labelFontSize': undefined,
            'labelBold': false,
            'labelItalic': false,
            'labelColorHex': undefined
          }
        },
        row,
        targetPosition
    );
  }

  createYearMonthField(row: DisguiseDto.DynamicDocumentRowDtoV2, targetPosition?: number) {
    this.createNewContentDialog(
        'Monatbaustein erstellen',
        {
          '@type': 'DynamicDocumentFieldDtoV2',
          'fieldType': {
            '@type': 'DynamicDocumentFieldTypeYearMonthDtoV2',
            'label': '',
            'context': undefined,
            'value': undefined,
            'min': undefined,
            'max': undefined,
            'readOnly': false,
            'horizontalAlignment': 'LEFT',
            'mandatory': false,
            'valueFontSize': undefined,
            'valueBold': false,
            'valueItalic': false,
            'valueColorHex': undefined,
            'labelFontSize': undefined,
            'labelBold': false,
            'labelItalic': false,
            'labelColorHex': undefined
          }
        },
        row,
        targetPosition
    );
  }

  createSignatureField(row: DisguiseDto.DynamicDocumentRowDtoV2, targetPosition?: number) {
    this.createNewContentDialog(
        'Unterschrift erstellen',
        {
          '@type': 'DynamicDocumentFieldDtoV2',
          'fieldType': {
            '@type': 'DynamicDocumentFieldTypeSignatureDtoV2',
            'label': undefined,
            'readOnly': undefined,
            'mandatory': undefined,
            'labelAsInputField': undefined,
            'prefillByUserSignatureTemplate': undefined,
            'labelInputFieldValue': undefined,
            'afterCaptureEvent': undefined,
            'beforeCaptureEvent': undefined,
            'labelFontSize': undefined,
            'labelBold': undefined,
            'labelItalic': undefined,
            'labelColorHex': undefined,
            'drawColorHex': undefined,
            'drawBackgroundColorHex': undefined,
          }
        },
        row,
        targetPosition
    );
  }

  createCheckboxField(row: DisguiseDto.DynamicDocumentRowDtoV2, targetPosition?: number) {
    this.createNewContentDialog(
        'Checkbox erstellen',
        {
          '@type': 'DynamicDocumentFieldDtoV2',
          'fieldType': {
            '@type': 'DynamicDocumentFieldTypeCheckboxDtoV2',
            'label': undefined,
            'value': undefined,
            'readOnly': undefined,
            'horizontalAlignment': 'LEFT',
            'mandatory': undefined,
            'checkboxSize': undefined,
            'labelFontSize': undefined,
            'labelBold': undefined,
            'labelItalic': undefined,
            'labelColorHex': undefined,
          }
        },
        row,
        targetPosition
    );
  }

  createTableField(row: DisguiseDto.DynamicDocumentRowDtoV2, targetPosition?: number) {
    this.createNewContentDialog(
        'Tabelle erstellen',
        {
          '@type': 'DynamicDocumentFieldDtoV2',
          'fieldType': {
            '@type': 'DynamicDocumentFieldTypeListTableDtoV2',
            'columns': [],
            'sections': [],
            'label': undefined,
            'rowSplitXs': undefined,
            'rowSplitSm': undefined,
            'rowSplitMd': undefined,
            'rowSplitLg': undefined,
            'rowSplitXl': undefined,
            'backgroundEvenColorHex': undefined,
            'backgroundOddColorHex': undefined,
            'horizontalLineColorHex': undefined,
            'horizontalLineWidth': undefined,
            'verticalLineColorHex': undefined,
            'verticalLineWidth': undefined,
          }
        },
        row,
        targetPosition,
        '90%'
    );
  }

  createMachineWorkingAreaBoundaryField(row: DisguiseDto.DynamicDocumentRowDtoV2, targetPosition?: number) {
    this.createNewContentDialog(
        'Arbeitsbereichsbegrenzung erstellen',
        {
          '@type': 'DynamicDocumentFieldDtoV2',
          'fieldType': {
            '@type': 'DynamicDocumentFieldTypeMachineWorkingAreaBoundaryDtoV2'
          }
        },
        row,
        targetPosition,
        '90%'
    );
  }

  getRowAlign(verticalAlignment: DisguiseDto.DynamicDocumentRowVerticalAlignmentDto) {
    let result = 'start';
    if (verticalAlignment) {
      switch (verticalAlignment) {
        case 'BOTTOM':
          result = 'end';
          break;
        case 'CENTER':
          result = 'center';
          break;
        default:
          break;
      }
    }
    return result;
  }


  private createNewContentDialog(
      title: string,
      content: DisguiseDto.DynamicDocumentFieldDtoV2,
      row: DisguiseDto.DynamicDocumentRowDtoV2,
      targetPosition: number | undefined,
      maxWidth?: number | string
  ) {
    this.contentDialog = {
      content,
      headerButtons: [{
        icon: 'check',
        iconSize: 'LARGE',
        title: 'Übernehmen',
        onClick: (button: ContentDialogButton,
                  contentToBeSaved: DisguiseDto.DynamicDocumentFieldDtoV2) => {
          if (!row.fields) {
            row.fields = [];
          }
          if (targetPosition === undefined) {
            row.fields.push(contentToBeSaved);
          } else {
            const itemsClone = [...row.fields];
            itemsClone.splice(targetPosition, 0, contentToBeSaved);
            row.fields = itemsClone;
          }
          this.showContentDialog = false;
          this.contentDialog = {};
        },
        disabled: false,
        loading: false
      }],
      onClose: () => {
        this.showContentDialog = false;
        this.contentDialog = {};
      },
      title,
      maxWidth: maxWidth ? maxWidth : 800
    };
    this.showContentDialog = true;
  }


  private createEditContentDialog(
      title: string,
      formField: DisguiseDto.DynamicDocumentFieldDtoV2,
      row: DisguiseDto.DynamicDocumentRowDtoV2,
      maxWidth?: number | string
  ) {
    this.contentDialog = {
      content: cloneDeep(formField),
      headerButtons: [{
        icon: 'check',
        iconSize: 'LARGE',
        title: 'Übernehmen',
        onClick: (button: ContentDialogButton,
                  content: DisguiseDto.DynamicDocumentFieldDtoV2) => {
          if (content && row && row.fields) {
            row.fields[row.fields.indexOf(formField)] = content;
          }
          this.showContentDialog = false;
          this.contentDialog = {};
        },
        disabled: false,
        loading: false
      }],
      onClose: () => {
        this.showContentDialog = false;
        this.contentDialog = {};
      },
      title,
      maxWidth: maxWidth ? maxWidth : 800
    };
    this.showContentDialog = true;
  }
}
